//SHARED CONSTANTS

export const UUID = 'uuid';
export const USER_ID = 'user_id';
export const USER_DB_ID = 'user_id';
export const TENANT_ID = 'tenant_id';
export const TENANT_DB_ID = 'tenant_id';
export const CREATED_BY = 'created_by';
export const CREATED_AT = 'created_at';
export const MODIFIED_BY = 'modified_by';
export const MODIFIED_AT = 'modified_at';
export const DELETED_BY = 'deleted_by';
export const DELETED_AT = 'deleted_at';
export const APPROVED_BY = 'approved_by';
export const APPROVED_ON = 'approved_on';
export const TENANT_NAME = 'tenant_name';
export const DB_PARENT_ID = 'parent_id';
export const DB_FIRST_LOGIN = 'first_login';
export const FCM_TOKEN = 'fcm_token';

//USER INFO

export const NAME = 'name';
export const ADDRESS_1 = 'address1';
export const ADDRESS_2 = 'address2';
export const CITY = 'city';
export const STATE = 'state';
export const COUNTRY = 'country';
export const PINCODE = 'pincode';
export const STATUS = 'status';
export const NURSE_ID = 'nurse_id';
export const HOSPITAL_ID = 'hospital_id';
export const HOSPITAL_NAME = 'hospital_name';
export const SLUG = 'slug';
export const ROLE = 'role';
export const DB_EMAIL = 'email';
export const DB_MOBILE = 'mobile_number';
export const DB_USER_DEVICE_ID = 'device_id';

//HOSPITAL INFO
export const HOSPITAL_BRANCH = 'hospital_branch';
export const HOSPITAL_EMAIL = 'hospital_email';
export const HOSPITAL_WEBSITE = 'hospital_website';
export const HOSPITAL_CONTACT = 'hospital_contact';
export const HOSPITAL_LOGO = 'hospital_logo';
export const HOSPITAL_TELEPHONE = 'hospital_telephone';
export const HOSPITAL_GST = 'gst';
export const PATIENT_NAME = 'patient_name';
export const MEDICINE_NAME = 'medicine_name';

//USER DELETION REASONS

export const REASONS = 'reasons';

//NOTES

export const NOTES = 'notes';

//HOSPITAL BLOCK

export const HOSPITAL_BLOCK_TYPE = 'type';
export const HOSPITAL_BLOCK_NAME = 'name';
export const HOSPITAL_BLOCK_ID = 'hospital_block_id';

// ROLE USER

export const ROLE_ID = 'role_id';

//DEVICES

export const DB_DEVICE_ID = 'device_id';
export const DB_DEVICE_TYPE = 'device_type';
export const DB_DEVICE_STATUS = 'device_status';
export const DB_STATUS = 'status';
export const DB_DEVICE_NAME = 'device_name';
export const DB_HOSPITAL_BLOCK_ID = 'hospital_block_id';

export const TERMS_ACCEPTED = 'terms_accepted';